import { render, staticRenderFns } from "./CompRight.vue?vue&type=template&id=49dd05b2&"
import script from "./CompRight.vue?vue&type=script&lang=ts&"
export * from "./CompRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports